import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import REPORT_HEADER from 'assets/images/report-header.webp';
import { IFeature } from 'graphql/types';
import { useFeature } from 'common/hooks/useFeature';
import { PageTitle } from 'common/components/PageTitle';
import { FourOFourPage } from 'hydra/pages/FourOFourPage';
import { SkillReportMatrix } from 'skill/components/SkillReportMatrix';
import { BackgroundImg } from 'common/components/Img';
import { BasePage } from 'hydra/pages/BasePage';
import { UpgradeContent } from 'skill/components/UpgradeContent';
import { Typography } from 'common/components/Typography';
import { useAppPermissions } from 'user/hooks/usePermissions';

export const SkillsMatrixPage = () => {
    const [translate] = useTranslation();

    const {
        canUse: canUseSkill,
        showSkills,
        userCanSeeUpgrade,
        loading: loadingFeature,
    } = useFeature(IFeature.Skill, true);

    const { canReadSkills = false } = useAppPermissions(
        'portfolioReport',
        'general'
    );

    const showUpgradePage = !canUseSkill && userCanSeeUpgrade;

    // User cannot use skill module and cannot see upgrade page
    if (
        (!loadingFeature && !canUseSkill && !userCanSeeUpgrade) ||
        (!canReadSkills && !userCanSeeUpgrade) ||
        !showSkills
    ) {
        return <FourOFourPage />;
    }

    const header = (
        <BackgroundImg
            src={REPORT_HEADER}
            sx={{
                height: '10vw',
                maxHeight: '150px',
                backgroundSize: 'contain',
                backgroundPosition: 'right top',
                display: { xs: 'none', sm: 'block' },
            }}
        />
    );

    return (
        <BasePage
            contentContainerMaxWidth="lg"
            header={!showUpgradePage && header}
        >
            <PageTitle>{translate('skillsMatrix.browserTitle')}</PageTitle>

            <Box sx={{ pt: !showUpgradePage ? 4 : 0 }}>
                {!showUpgradePage && (
                    <Typography sx={{ mb: 4 }} variant="h1">
                        {translate('skillsMatrix.pageTitle')}
                    </Typography>
                )}

                {!showUpgradePage && <SkillReportMatrix />}

                {showUpgradePage && <UpgradeContent />}
            </Box>
        </BasePage>
    );
};
